<script setup lang="ts">
withDefaults(
  defineProps<{
    url?: string
    bordered?: boolean
    centered?: boolean
    floating?: boolean
    companyBrandingLogoUrl?: string
  }>(),
  {
    bordered: false,
    centered: false,
    floating: false,
  }
)
const emit = defineEmits<{
  redirect: []
}>()
</script>
<template>
  <div
    class="header"
    :class="{ 'header--bordered': bordered, 'header--centered': centered, 'header--floating': floating }"
  >
    <nuxt-link v-if="url" :to="url" class="header__link" @click="emit('redirect')">
      <logo :image="companyBrandingLogoUrl" data-cy="indexLogo" class="sh__logo" />
    </nuxt-link>
    <logo v-else :image="companyBrandingLogoUrl" data-cy="indexLogo" class="sh__logo" />
  </div>
</template>

<style lang="scss" scoped>
.header {
  min-height: $siteheader-height;
  height: $siteheader-height;
  align-content: center;
  width: 100%;
  padding-inline: 2.5rem;
  &--floating {
    position: absolute;
    top: 0;
    left: 0;
    z-index: 1;
  }
  &--bordered {
    border-bottom: 1px solid #{$c-border};
  }
  &--centered {
    justify-items: center;
  }
  &__link {
    width: fit-content;
    display: block;
    text-decoration: none;
  }
}
</style>
